import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(5 * 60); // 5 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-red-600 text-white py-2 px-4 text-center text-sm md:text-base font-semibold flex items-center justify-center gap-2" data-id="element-118">
      <span className="animate-pulse" data-id="element-119">⚠️</span>
      <span data-id="element-120">ATENCIÓN: Oferta especial expira en</span>
      <span className="font-mono bg-black/20 px-2 py-0.5 rounded" data-id="element-121">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
    </div>;
}